import $ from '~/qwery';
import bean from '~/bean';

if (document.querySelector('.b-page.category-page')) {
    const $leftBlock = $('.b-left-block');
    const $filter = $('.b-filter', $leftBlock);
    const $products = $('.b-products');

    if ($filter.length) {
        const filter = {};
        $('.name', $filter).each(n => {
            filter[n.dataset.id] = []
        });

        function show(li) {
            return JSON.parse(li.dataset.productparams).every(nv => {
                return ! filter[nv['param.id']]
                    || ! filter[nv['param.id']].length
                    || filter[nv['param.id']].includes(nv['value.id']);
            });
        }

        bean.on($filter[0], 'change', e => {
            const valueId = e.target.dataset.id;
            const nameId = $(e.target).parent('ul').prev()[0].dataset.id;
            const $allCheckboxes = $('input', $(e.target).parent('ul'))
            const checkedIds = $allCheckboxes.toArray()
                .filter(c => c.checked)
                .map(c => Number(c.dataset.id));
            filter[nameId] = checkedIds;
            $('li', $products).each(li => {
                $(li)[show(li) ? 'removeClass' : 'addClass']('hidden');
            });
        });
    }
}



// WEBPACK FOOTER //
// ./makosh/assets/pages/category.js